export default {
  nav: {
    coreLogic: 'Kernlogik',
    profitMechanism: 'Gewinnmechanismus',
    profitFlywheel: 'Gewinn-Schwungrad',
    sysArch: 'Systemarchitektur',
    tradingExample: 'Handelsbeispiele',
    cta: 'Loslegen',
    language: 'Sprache',
  },
  hero: {
    badge: 'Poly Ai Claw Intelligenz-Engine',
    title1: 'Von der Prognose zur',
    title2: 'Wahrscheinlichkeitsarbitrage',
    desc: 'Polywin verwandelt Prognosemärkte in eine systematische Arbitrage-Engine, angetrieben durch die Poly Ai Claw Intelligence Engine',
    ctaPrimary: 'Poly Ai Claw Engine starten',
    ctaSecondary: 'Demo ansehen',
    statsEvents: 'Überwachte Ereignisse',
    statsSuccessRate: 'Ausführungserfolgsrate',
    statsExecTime: 'Ausführungszeit',
    cardTitle: 'Wahrscheinlichkeitsabweichungsanalyse',
    cardBadge: 'EV-Vorteilszone',
    cardMarketProb: 'Marktwahrscheinlichkeit',
    cardAiProb: 'KI-Wahrscheinlichkeit',
    cardMarketImplied: 'Implizierte Marktwahrscheinlichkeit',
    cardAiTrue: 'Wahre KI-Wahrscheinlichkeit',
    cardProbDiff: 'Wahrscheinlichkeitsvorteil',
  },
  coreLogic: {
    badge: 'PolyAi-Claw Entscheidungssystem',
    title1: 'Von der Datenaggregation zu Compound-Renditen —',
    title2: 'Vollautomatischer Kreislauf',
    desc: 'Mehrdatenquellen → KI-Modellierung → Wahrscheinlichkeitsabweichung → Auto-Ausführung → Compound-Renditen',
    step0_title: 'Datenschicht',
    step0_sub: 'Multi-Quellen-Aggregation',
    step0_i0: 'Politische Ereignisse',
    step0_i1: 'Makroökonomie',
    step0_i2: 'Soziale Stimmung',
    step0_i3: 'Orderbuchdaten',
    step1_title: 'KI-Modellierung',
    step1_sub: 'Bayesianisches Wahrscheinlichkeitsupdate',
    step1_i0: 'Echtzeit-Dateneingabe',
    step1_i1: 'KI-Modellierungs-Engine',
    step1_i2: 'Wahrscheinlichkeitsberechnung',
    step1_i3: 'Modelloptimierung',
    step2_title: 'Abweichungserkennung',
    step2_sub: 'Wahrscheinlichkeitsabweichungs-ID',
    step2_i0: 'Implizierte Marktwahrscheinlichkeit',
    step2_i1: 'Wahre KI-Wahrscheinlichkeit',
    step2_i2: 'EV-Vorteilserkennung',
    step2_i3: 'Positionssignal',
    step3_title: 'On-Chain-Ausführung',
    step3_sub: 'Polygon Auto-Trade',
    step3_i0: 'Risikosteuerung',
    step3_i1: 'Kapitalallokation',
    step3_i2: 'USDC-Abrechnung',
    step3_i3: 'Smart Contract',
    step4_title: 'Compound-Renditen',
    step4_sub: 'Auto-Reinvestition',
    step4_i0: 'Ereignisabrechnung',
    step4_i1: 'Gewinnliquidation',
    step4_i2: 'Compound-Berechnung',
    step4_i3: 'Reinvestitionskreislauf',
    keyTitle: 'Kernziel',
    keyDesc: 'Das Ziel von PolyAi-Claw ist es, kontinuierlich Wahrscheinlichkeits-Fehlbewertungen im Markt zu identifizieren und systematische Arbitrage auszuführen.',
    keyHighlight: 'kontinuierlich Wahrscheinlichkeits-Fehlbewertungen identifizieren und systematische Arbitrage ausführen',
  },
  profitMechanism: {
    badge: 'Kerngewinnmechanismus',
    title1: 'Die drei Gewinnmechanismen',
    title2: 'von PolyAi-Claw',
    desc: 'Ein stabiles Wahrscheinlichkeitsarbitrage-System durch EV-Vorteilserkennung, Millisekunden-Ausführung und dreistufiges Kapitalmanagement',
    m1_title: 'EV-Vorteilserkennung',
    m1_sub: 'Wahrscheinlichkeitsvorteilserkennung',
    m1_desc: 'Kernlogik: Marktpreis ≠ Wahre Wahrscheinlichkeit. Wenn KI eine Abweichung erkennt, tritt das System automatisch in die EV-Vorteilszone ein.',
    m1_marketImplied: 'Implizierte Marktwahrscheinlichkeit',
    m1_aiTrue: 'Wahre KI-Wahrscheinlichkeit',
    m1_probDiff: 'Wahrscheinlichkeitsvorteil',
    m1_note: 'Gleiche Logik wie Optionsarbitrage in Quant-Fonds',
    m2_title: 'Millisekunden-Auto-Ausführung',
    m2_sub: 'Millisekunden-Ausführung',
    m2_desc: 'Vollautomatisches Ausführungs-Framework stellt sicher, dass keine Arbitrage-Möglichkeit durch menschliche Fehler verloren geht.',
    m2_i0_title: 'Ausführungsgeschwindigkeit in Millisekunden',
    m2_i0_sub: 'Durchschn. <200ms',
    m2_i1_title: 'Vollständig On-Chain transparent',
    m2_i1_sub: 'Polygon PoS',
    m2_i2_title: 'Null menschliches Eingreifen',
    m2_i2_sub: 'Smart Contract Auto-Abrechnung',
    m2_network_label: 'Ausführungsnetzwerk',
    m2_network_val: 'Polygon + USDC',
    m3_title: 'Dreistufiges Kapitalmanagement',
    m3_sub: 'Dreistufige Risikosteuerung',
    m3_desc: 'Dreischichtige Kapitalstruktur gewährleistet langfristigen stabilen Systembetrieb.',
    m3_i0_title: 'Stabiler Rendite-Pool',
    m3_i0_desc: 'Hochsichere Wahrscheinlichkeitsarbitrage, geringstes Risiko',
    m3_i1_title: 'Volatilitätsarbitrage-Pool',
    m3_i1_desc: 'Erfasst Marktvolatilität, hohe Renditeanpassungsfähigkeit',
    m3_i2_title: 'Absicherungs-Pool',
    m3_i2_desc: 'Niedrig korrelierte Ereignisabsicherung, reduziertes Systemrisiko',
    m3_risk: 'Einzelereignis-Exponierung < 5%',
    formula_title: 'Wahrscheinlichkeitsarbitrage-Formel',
    formula_marketPrice: 'Marktpreis',
    formula_aiTrue: 'Wahre KI-Wahrscheinlichkeit',
    formula_trigger: 'Position auslösen',
    formula_arbitrage: 'Arbitrage',
    formula_hiddenPct: 'Impliziert 60%',
    formula_evEdge: 'EV-Vorteil +12%',
    formula_autoExec: 'Auto-Ausführen',
  },
  fundManagement: {
    riskTitle: 'Kernprinzipien der Risikosteuerung',
    riskDesc: 'Das System legt eine maximale Einzelereignis-Exponierung von < 5% fest, um sicherzustellen, dass selbst extreme Ergebnisse den Gesamtfonds nicht wesentlich beeinflussen.',
    riskHighlight: 'maximale Einzelereignis-Exponierung < 5%',
    stat_maxSingle: 'Max. Einzelinvestition',
    stat_maxSingleVal: '5%',
    stat_diversify: 'Kapitalstreuung',
    stat_diversifyVal: '20+ Ereignisse',
    stat_stopLoss: 'Stop-Loss-Mechanismus',
    stat_stopLossVal: 'Auto-ausgelöst',
    vizTitle: 'Risikosteuerungs-Visualisierung',
    viz_exposure: 'Exponierungssteuerung',
    viz_diversify: 'Kapitalstreuung',
    viz_correlation: 'Ereigniskorrelation',
    viz_stability: 'Strategiestabilität',
  },
  techAdvantage: {
    badge: 'Kernvorteile',
    title1: 'Warum PolyAi-Claw',
    title2: 'traditionelle Prognosemärkte übertrifft?',
    dim_decision: 'Entscheidungsgrundlage',
    dim_monitor: 'Überwachungshäufigkeit',
    dim_execute: 'Ausführungsmethode',
    dim_model: 'Kognitives Modell',
    dim_risk: 'Risikosteuerung',
    human_decision: 'Emotionsgetrieben',
    human_monitor: 'Niederfrequent',
    human_execute: 'Manuelle Orders',
    human_model: 'Subjektiv',
    human_risk: 'Erfahrungsbasiert',
    ai_decision: 'Datengetrieben',
    ai_monitor: 'Hochfrequent',
    ai_execute: 'Auto-Ausführung',
    ai_model: 'Wahrscheinlichkeitsmodell',
    ai_risk: 'Algorithmisch verwaltet',
    humanPredict: 'Menschliche Prognose',
    adv1_title: 'Datenbasiert vs. Emotionsgesteuert',
    adv1_desc: 'PolyAi-Claw modelliert auf Basis von Mehrdatenquellen und berechnet echte Wahrscheinlichkeiten in Echtzeit mithilfe bayesianischer Wahrscheinlichkeitsupdates.',
    adv1_label: 'Datenquellen',
    adv2_title: 'Hochfrequent vs. Niederfrequent',
    adv2_desc: 'Das System überwacht Marktveränderungen 24/7 ununterbrochen und identifiziert Wahrscheinlichkeitsabweichungen in Echtzeit.',
    adv2_label: 'Überwachungshäufigkeit',
    adv3_title: 'Auto-Ausführung vs. Manuelle Orders',
    adv3_desc: 'Millisekunden-Auto-Ausführung über Smart Contracts im Polygon-Netzwerk — ohne menschliches Eingreifen.',
    adv3_label: 'Ausführungsgeschwindigkeit',
    adv4_title: 'Algorithmus vs. Erfahrung',
    adv4_desc: 'Dreistufiges Kapitalverwaltungssystem mit strikt unter 5% gehaltener Einzelereignis-Exponierung.',
    adv4_label: 'Risikosteuerung',
    conclusion_title: 'Vom Prognosemarkt zur Poly Ai Claw Intelligence Engine',
    conclusion_desc1: 'Dies verwandelt PolyWin von einem einfachen Prognosemarkt in',
    conclusion_brand: 'Poly Ai Claw Intelligence Engine',
    conclusion_desc2: 'Das quantitative Prognosesystem Poly Ai Claw',
  },
  productNarrative: {
    badge: 'Produktpositionierung',
    title: 'Die wahre Identität von PolyWin',
    desc: 'PolyWin ist nicht nur ein Prognosemarkt — es ist ein integriertes System, das KI, Prognosemärkte, OpenClaw und quantitativen Handel kombiniert.',
    item0_title: 'Wahrscheinlichkeitsarbitrage-System',
    item0_sub: 'Erfasst kontinuierlich Markt-Fehlbewertungen',
    item1_title: 'Diszipliniertes Ausführungsmodell',
    item1_sub: 'Automatisiert, null emotionale Einmischung',
    item2_title: 'KI-Risikomanagement-Engine',
    item2_sub: 'Intelligente Risikosteuerung für Sicherheit',
    visual_title: 'Drei visuelle Ausdrücke',
    vis0_title: '① Wahrscheinlichkeitskurven-Abweichungsdiagramm',
    vis0_desc: 'Zeigt KI-Wahrscheinlichkeitskurve vs. Marktpreiskurve',
    vis0_ai: 'KI-Wahrscheinlichkeit',
    vis0_market: 'Marktpreis',
    vis0_diff: 'Wahrscheinlichkeitsdifferenz',
    vis1_title: '② Risikosteuerungs-Radardiagramm',
    vis1_desc: 'Zeigt Risikoexponierung, Kapitalstreuung, Ereigniskorrelation und Strategiestabilität',
    vis1_exposure: 'Risikoexponierung',
    vis1_diversify: 'Kapitalverteilung',
    vis1_safe: 'Sichere Zone',
    vis1_safeVal: 'Erreicht',
    vis2_title: '③ KI Auto-Trade Flussdiagramm',
    vis2_desc: 'Vollständiger Kreislauf: Daten → KI → Ausführen → Abrechnen → Compounding',
    vis2_exec: 'Ausführungsgeschwindigkeit',
    vis2_execVal: 'Millisekunden',
    vis2_auto: 'Automatisierungsgrad',
    vis2_compound: 'Compounding-Kreislauf',
    vis2_compoundVal: 'Kontinuierlich',
    core_title: 'Kernwertversprechen',
    core_desc: 'Durch automatisiertes Wahrscheinlichkeits-Pricing und zeitliches Compounding erfasst PolyAi-Claw kontinuierlich Preisabweichungen.',
    core_highlight: 'automatisiertes Wahrscheinlichkeits-Pricing und zeitliches Compounding',
    core_item0: 'Automatisiertes Wahrscheinlichkeits-Pricing',
    core_item1: 'Zeitlicher Compounding-Mechanismus',
    core_item2: 'Risikosteuerungs-Garantie',
    core_item3: 'Kontinuierliche Abweichungserfassung',
  },
  profitFlywheel: {
    badge: 'KI-getriebenes finanzielles Wachstumsschwungrad',
    title1: 'PolyWin KI',
    title2: 'Gewinn-Schwungrad-Modell',
    desc: 'PolyWins Wachstum basiert nicht auf Einzelhandelsgewinnen — es stützt sich auf ein KI-gesteuertes kontinuierliches Compounding-System',
    descHighlight: 'KI-gesteuertes kontinuierliches Compounding-System',
    aiCore: 'KI-Wahrscheinlichkeits-Engine',
    step1_title: 'Globale Dateneingabe',
    step1_sub: 'Globale Daten',
    step1_desc: 'KI überwacht kontinuierlich Nachrichtenereignisse, politische Änderungen, makroökonomische Daten, soziale Stimmung und Prognosemarkt-Orderbücher',
    step1_tech: '50+ Datenquellen',
    step1_techDetail: 'Multi-Quellen-Echtzeit-Fusion',
    step2_title: 'KI-Wahrscheinlichkeitsmodellierung',
    step2_sub: 'Wahrscheinlichkeitsmodellierung',
    step2_desc: 'Verwendet bayesianische Wahrscheinlichkeitsmodelle zur Berechnung echter Wahrscheinlichkeiten',
    step2_tech: 'Bayesianisches Modell',
    step2_techDetail: 'Dynamisches Echtzeit-Wahrscheinlichkeitsupdate',
    step3_title: 'Wahrscheinlichkeitsabweichung erkennen',
    step3_sub: 'Wahrscheinlichkeitsvorteil',
    step3_desc: 'Wenn wahre KI-Wahrscheinlichkeit > implizierte Marktwahrscheinlichkeit, als EV-positive Gelegenheit identifiziert',
    step3_tech: 'EV-Abweichung >5%',
    step3_techDetail: 'Auto-Erkennung positiver EV',
    step4_title: 'Auto-Trade-Ausführung',
    step4_sub: 'Algorithmische Ausführung',
    step4_desc: 'System schließt automatisch Positionsaufbau, Absicherung und Orderausführung im Polygon-Netzwerk ab',
    step4_tech: 'Smart Contract',
    step4_techDetail: '<200ms Millisekunden-Ausführung',
    step5_title: 'Prognosemarkt-Gewinn',
    step5_sub: 'Marktgewinn',
    step5_desc: 'Wenn Ereignisergebnis bestätigt oder Marktwahrscheinlichkeit zurückgekehrt, erzielt das System Arbitrage-Renditen',
    step5_tech: 'Polygon PoS',
    step5_techDetail: 'On-Chain Auto-Abrechnung',
    step6_title: 'Kapitalrückgewinnung',
    step6_sub: 'Kapitalrecycling',
    step6_desc: 'Das System gibt automatisch profitables Kapital in den Fonds zurück',
    step6_tech: 'USDC-Abrechnung',
    step6_techDetail: 'Stablecoin ohne Währungsverluste',
    step7_title: 'Compound-Wachstum',
    step7_sub: 'Compound-Kapital',
    step7_desc: 'Mit wachsendem Fonds kann KI an größeren Märkten und mehr Arbitrage-Möglichkeiten teilnehmen',
    step7_tech: 'Auto-Compounding',
    step7_techDetail: 'Gewinn-Auto-Reinvestitions-Kreislauf',
    step8_title: 'Größere Kapitalskala',
    step8_sub: 'Größerer Liquiditätspool',
    step8_desc: 'Größeres Kapital bedeutet höhere Handelskapazität und stabilere Renditen',
    step8_tech: 'Liquiditätserweiterung',
    step8_techDetail: 'Skalenvorteil compoundiert',
    sum0_label: 'Datenschicht',
    sum0_tech: '50+ Multi-Quellen-Streams',
    sum0_detail: 'Bayesianische Echtzeit-Modellierung',
    sum1_label: 'Ausführungsschicht',
    sum1_tech: 'Smart Contract Automatisierung',
    sum1_detail: 'Polygon PoS On-Chain-Abrechnung',
    sum2_label: 'Abrechnungsschicht',
    sum2_tech: 'USDC Stablecoin',
    sum2_detail: 'Abrechnung ohne Währungsverluste',
    sum3_label: 'Compounding-Schicht',
    sum3_tech: 'Auto-Reinvestition',
    sum3_detail: 'Positiver Kreislauf der Skalenerweiterung',
    key0_title: 'Selbstverstärkender Kreislauf',
    key0_desc: 'Jeder Gewinn stärkt die Systemfähigkeiten und bildet positive Rückkopplungsschleifen für exponentielles Wachstum',
    key1_title: 'KI-gesteuertes Wachstum',
    key1_desc: 'Wachstum hängt nicht von Empfehlungen ab — es stützt sich auf die eigene Wahrscheinlichkeitsarbitrage-Fähigkeit der KI',
    key2_title: 'Kontinuierliches Compounding-System',
    key2_desc: 'Durch automatisierte Gewinnrückgewinnung und Reinvestition expandiert der Fonds kontinuierlich',
    formula_title: 'Schwungrad-Wachstumsformel',
    f0_label: 'KI-Daten',
    f1_label: 'Wahrscheinlichkeitsarbitrage',
    f2_label: 'Gewinn',
    f3_label: 'Compounding',
    f4_label: 'Mehr Kapital',
    f5_label: 'Mehr Arbitrage',
    connected: 'Verbunden · Live',
  },
  sysArch: {
    badge: 'Offizielle Architektur',
    title1: 'PolyAi-Claw KI',
    title2: 'Systemarchitektur',
    desc: 'Ein vollständiges KI-Entscheidungssystem von der Datenerfassung bis zur Auto-Abrechnung mit Risikosteuerungsmodellen auf Quant-Fonds-Niveau',
    coreBadge: 'Kern-KI-Gehirn',
    feat0_title: 'Vollständige KI-Systemstruktur',
    feat0_desc: 'Nicht nur eine Strategie — ein vollständiges KI-Entscheidungssystem, das den gesamten Ablauf abdeckt',
    feat1_title: 'Risikosteuerung auf Quant-Fonds-Niveau',
    feat1_desc: 'Professionelle Quant-Fonds-Risikosteuerungsmodelle einschließlich Exponierungssteuerung, Korrelationsabsicherung und dynamischer Kapitalallokation',
    feat2_title: 'Skalierbare Architektur',
    feat2_desc: 'Zukünftig erweiterbar auf Multi-Markt, Multi-Chain, Multi-Strategie',
    dataflow_title: 'Datenfluss',
  },
  tradingExample: {
    badge: 'Live-Fallstudie',
    title1: 'PolyAi-Claw BTC',
    title2: '5-Minuten-Arbitrage-Strategie',
    desc: 'Das System macht nur drei Dinge: Abnormale Volatilität erkennen → Wahrscheinlichkeitsbeurteilung der letzten 60 Sekunden → Handel in der sicheren Zone',
    s1_title: 'BTC-Marktdaten',
    s1_sub: 'Echtzeit-Marktüberwachung',
    s1_notice: 'Beispieldaten für Strategie-Auslösebedingungen',
    s1_price: 'Aktueller Preis',
    s1_eg: 'Beispiel',
    s1_priceVol: 'Preisvolatilität',
    s1_vol: 'Volumen',
    s1_depth: 'Orderbuchtiefe',
    s1_trigger: 'Auslöser: Volatilität ≥ 100 USD',
    s1_met: 'Erfüllt',
    s2_title: 'PolyAi-Claw Engine',
    s2_sub: 'KI-Wahrscheinlichkeitsberechnung',
    s2_marketImplied: 'Implizierte Marktwahrscheinlichkeit',
    s2_aiTrue: 'Wahre KI-Wahrscheinlichkeit',
    s2_yes: 'JA',
    s2_probDiff: 'Wahrscheinlichkeitsvorteil',
    s2_safe: 'Eintreten in sichere Handelszone',
    s3_title: 'Auto-Trade + Gewinn',
    s3_sub: 'Auto-Ausführung & Renditen',
    s3_exec: 'Handelsausführung',
    s3_buyYes: 'JA kaufen',
    s3_buyPrice: 'Einstiegspreis',
    s3_settlement: 'Prognosemarkt-Abrechnung',
    s3_correct: 'Richtige Prognose',
    s3_profit: 'Rendite pro Trade',
    s3_avg: 'Durchschnittliche Rendite',
    s3_recycle: 'Renditen werden in Pool recycelt',
    chart_title: 'KI-Wahrscheinlichkeit vs. Marktwahrscheinlichkeitsabweichung',
    chart_sub: 'Echtzeit-Tracking der Abweichung der Poly Ai Claw Engine von der Marktpreiswahrscheinlichkeit',
    chart_live: 'Live-Analyse',
    chart_curDev: 'Aktuelle Abweichung',
    chart_signal: 'Arbitrage-Signal',
    chart_signalVal: 'Ausgelöst',
    chart_winRate: 'Gewinnraten-Prognose',
    chart_bottom_implied: 'Implizierte Marktwahrscheinlichkeit',
    chart_bottom_dev: 'Wahrscheinlichkeitsabweichungszone',
    chart_bottom_dev_sub: 'Arbitrage-Gelegenheit ausgelöst',
    chart_bottom_ai: 'Wahre KI-Wahrscheinlichkeit',
    chart_bottom_ai_sub: 'Poly Ai Claw Modellausgabe',
    chart_bottom_implied_sub: 'Basierend auf Marktpreis',
    chart_marketProb: 'Implizierte Marktwahrsch.',
    chart_aiProb: 'Wahre KI-Wahrscheinlichkeit',
    chart_deviationArea: 'Arbitrage-Abweichungszone',
    maxDeviation: 'Max. Abweichung',
    deviation: 'Abweichung',
    flow_title: 'Vollständiger Strategieablauf',
    flow0_title: 'BTC-Datenüberwachung',
    flow0_desc: 'Live-Preis/Volumen',
    flow1_title: 'Volatilitätserkennung',
    flow1_desc: '≥ 100 USD',
    flow2_title: 'Zeitfilter',
    flow2_desc: 'Letzte 60 Sekunden',
    flow3_title: 'Gewinnraten-Bewertung',
    flow3_desc: '≥ 60-70%',
    flow4_title: 'Auto-Ausführung',
    flow4_desc: 'JA/NEIN kaufen',
    flow5_title: 'Marktabrechnung',
    flow5_desc: '1 USDC',
    flow6_title: 'Compound-Renditen',
    flow6_desc: '3%-10%',
    risk0_title: 'Risikosteuerungsstruktur',
    risk0_i0: 'Einzelereignis-Kapitallimit < 5%',
    risk0_i1: 'Multi-Ereignis-Diversifikation',
    risk0_i2: 'KI-dynamischer Stop-Loss',
    risk1_title: 'Timing-Strategie',
    risk1_i0: 'Ausführung in letzten 60 Sekunden',
    risk1_i1: 'Emotionalen Handel vermeiden',
    risk1_i2: 'Vollständigere Informationen',
    risk2_title: 'Historische Performance',
    risk2_i0: 'Historische Gewinnrate 80%-90%',
    risk2_i1: 'Durchschnittliche Rendite 3%-10%',
    risk2_i2: 'Stabiles Arbitrage-Modell',
  },
  crossPlatform: {
    badge: 'Plattformübergreifende Prognose-Arbitrage',
    title1: 'PolyAi CLaw',
    title2: 'Plattformübergreifende Prognosemarkt-Arbitrage-Logik',
    desc: 'Verbindet Polymarket (Web3) und Kalshi (Fiat) — erfasst Preisabweichungen mit intelligenter Zuordnung und ultraschneller Ausführung',
    polymarket: 'Polymarket',
    kalshi: 'Kalshi',
    web3: 'Web3',
    fiat: 'Fiat',
    claw: 'CLaw',
    matched: '✓ Zugeordnet',
    matching: 'Zuordnung...',
    sec1_badge: '01',
    sec1_accuracy: '99%+ Genauigkeit',
    sec1_title: 'Intelligente Marktzuordnung',
    sec1_desc: 'Ereignisse auf beiden Plattformen werden automatisch durch semantische KI gebunden und identifizieren plattformübergreifende Spreads in Millisekunden',
    sec2_badge: '02',
    sec2_ms: 'Millisekunden-Ausführung',
    sec2_title: 'Einheitliche Integration & ultraschneller Handel',
    sec2_desc: 'Einheitliches API/SDK verbindet mehrere Plattformen mit millisekunden-synchroner Orderplatzierung',
    connected: 'Verbunden · Live',
    latency: 'Order-Latenz',
    dailyEvents: 'Täglich zugeordnete Ereignisse',
    successRate: 'Ausführungserfolgsrate',
    platforms: 'Synchronisierte Plattformen',
    sec3_badge: '03',
    sec3_analytics: 'Live-Analytik',
    sec3_title: 'Arbitrage-Datenvisualisierung',
    sec3_desc: 'Echtzeit-Preisabweichung, Arbitrage-Renditen und Wachstumstrends — dynamisch präsentiert',
    priceDeviation: 'Preisabweichungsverteilung',
    volumeTitle: 'Monatliches Volumen (K USDC)',
    h1Volume: 'H1 kumuliertes Volumen (USDC)',
    arbIndicators: 'Arbitrage-Vorteils-Metriken',
    arbSuccess: 'Spread-Arbitrage-Erfolgsrate',
    semanticAccuracy: 'Semantische Zuordnungsgenauigkeit',
    liquidity: 'Plattformübergreifende Liquidität',
    hedgeCoverage: 'Absicherungsdeckungsrate',
  },
  mathAlgo: {
    badge: 'Präzise fortgeschrittene mathematische Algorithmen',
    title1: 'Polymarket-Arbitrage ist kein',
    title2: 'einfaches Mathematikproblem',
    quote: 'Während Sie noch manuell diese Addition durchführen, macht das Quant-System etwas völlig anderes.',
    quoteHighlight1: 'manuell diese Addition durchführen',
    quoteHighlight2: 'etwas völlig anderes',
    ch0_title: 'Was ist Arbitrage? Warum gibt es so viel davon auf Polymarket?',
    ch0_tag: 'Marktineffizienz',
    ch1_title: 'Cross-Market-Arbitrage: Logische Abhängigkeiten',
    ch1_tag: 'Kombinatorische Mathematik',
    ch2_title: 'Bregman-Projektion: Berechnung der optimalen Arbitragegröße',
    ch2_tag: 'Konvexe Optimierung',
    pipeline_title: 'Polymarket Arbitrage-System — Vollständige Architektur',
    layer0: 'Schicht 1: Datenerfassung',
    layer1: 'Schicht 2: Abhängigkeitserkennung',
    layer2: 'Schicht 3: Dreistufige Optimierungs-Engine',
    layer3: 'Schicht 4: Ausführung & Positionsmanagement',
    annualProfit: 'Jährlicher Gesamtgewinn extrahiert: $39.688.585',
    venn_title: 'Logische Abhängigkeit: P(Mit 5% gewinnen) ⊆ P(Gewinnen)',
    contradiction: 'Widerspruch! P(Teilmenge) > P(Elternteil) → Arbitrage-Signal ausgelöst',
    contradiction_sub: '0,55 > 0,48 → Logischer Widerspruch → Arbitrage-Gelegenheit',
    combinations: 'Marktkombinationen',
    brutal: 'Brute-Force unmöglich',
    integerConstraints: 'Integer-Programmierung-Einschränkungen',
    replaces: 'Ersetzt 16.384 Enumerationen',
    bregman_title: 'KL-Divergenz vs. Euklidische Distanz',
    coreData: 'Kerndaten',
    pipeline4: '4-schichtiger System-Pipeline',
    annualReturn: 'Jahresgewinn ≈ $39,7M',
    whyNotEnough_title: 'Warum reicht "Preissumme = $1" nicht aus?',
    singleMarket: 'Einzelmarkt — Sieht gut aus',
    crossMarket: 'Cross-Market — Exponentielle Explosion',
  },
  mathProfit: {
    ch3_title: 'Frank-Wolfe-Algorithmus: Schrittweise zur Antwort',
    ch3_tag: 'Iterativer Algorithmus',
    ch3_chapter: 'Kapitel 04',
    execTitle: 'Nicht-atomares Ausführungsrisiko',
    profitStructure: 'Gewinnstruktur (Apr. 2024 – Apr. 2025)',
    totalProfit: 'Gesamt: $39.688.585',
    top10: 'TOP 10 machte 20,5% aus',
    kellyFormula: 'Modifizierte Kelly-Positionsformel',
    preTrade: 'Vor-Trade 4 Checkpoints',
    gate0: 'Ausreichende Liquidität?',
    gate1: 'Akzeptabler Slippage?',
    gate2: 'Nach Slippage noch profitabel?',
    gate3: 'Gewinn > $0,05 → Ausführen',
  },
  safuFund: {
    badge: 'Vermögenssicherheitsgarantie',
    title: 'Polywin SAFU Fonds',
    titleHighlight: 'SAFU Fonds',
    desc: 'On-Chain gesperrte Reserven, transparent und in Echtzeit verifizierbar — Ihre Vermögenswerte, unser Versprechen',
    reserveLabel: 'Gesamtreserve · USDC · Ethereum Mainnet',
    verified: 'On-Chain verifiziert',
    mainDesc: 'Das Polywin-Team hat 10 Millionen USDC als SAFU-Sicherheitsreservefonds im Ethereum-Mainnet gesperrt, um Benutzerassets bei einem Hack zu schützen. Alle Mittel sind vollständig transparent und über Etherscan in Echtzeit von jedem überprüfbar.',
    mainDescHighlight: '10 Millionen USDC',
    contractLabel: 'Vertragsadresse',
    etherscanBtn: 'Auf Etherscan verifizieren',
    stat0_label: 'Reservegröße',
    stat0_sub: 'USDC',
    stat1_label: 'On-Chain-Sperrrate',
    stat1_sub: 'On-Chain',
    stat2_label: 'Verifizierbar',
    stat2_sub: 'Echtzeit',
    stat3_label: 'Historische Auszahlungen',
    stat3_val: '$0',
    stat3_sub: 'Null-Verlust-Rekord',
    f0_title: 'On-Chain gesperrt',
    f0_desc: '100% der Mittel sind in Ethereum-Mainnet-Smart-Contracts gesperrt — das Team kann nicht willkürlich abheben oder transferieren',
    f1_title: 'Vollständig transparent',
    f1_desc: 'Jeder kann den Fondssaldo und alle historischen Transaktionen in Echtzeit über Etherscan einsehen',
    f2_title: 'Schnelle Entschädigung',
    f2_desc: 'Entschädigungsprozess innerhalb von 72 Stunden nach bestätigtem Sicherheitsvorfall eingeleitet',
    f3_title: 'Unabhängiges Audit',
    f3_desc: 'Drittanbieter-Sicherheitsagenturen prüfen regelmäßig den Vertragscode, um die Echtheit der Reservemittel zu gewährleisten',
  },
  cta: {
    badge: 'Jetzt loslegen',
    title1: 'Beginnen Sie mit',
    title2: 'Poly Ai Claw',
    title3: 'Intelligence Engine',
    desc: 'Keine Programmierkenntnisse erforderlich — konfigurieren Sie KI-Strategien in 3 Minuten',
    btn: 'AI-Claw starten',
    trust0: 'Offizieller Polygon-Partner',
    trust1: 'Von Auditfirma zertifiziert',
    trust2: '10.000+ aktive Nutzer',
    trust3: '$50M+ kumuliertes Volumen',
  },
  footer: {
    tagline: 'Poly Ai Claw Intelligence Engine',
    product: 'Produkt',
    resources: 'Ressourcen',
    social: 'Soziale Medien',
    link0: 'Poly AI-Claw Algorithmus',
    link1: 'Risikosteuerungssystem',
    link2: 'Daten-API',
    link3: 'Entwickler-Dokumentation',
    res0: 'Tutorial',
    res1: 'Strategie-Fallstudien',
    res2: 'Whitepaper',
    res3: 'Community-Forum',
    copyright: '© 2026 PolyWin. Alle Rechte vorbehalten.',
    privacy: 'Datenschutzrichtlinie',
    terms: 'Nutzungsbedingungen',
  },
};
